
interface CostSummaryProps {
  totalItemAmount: number;
  totalQuantity: number;
  totalUnitCost: number;
  totalAdditionalCosts: number;
  grandTotal: number;
  vatApplicable: boolean;
  itemsCount: number;
}

export const CostSummary = ({
  totalItemAmount,
  totalQuantity,
  totalUnitCost,
  totalAdditionalCosts,
  grandTotal,
  vatApplicable,
  itemsCount
}: CostSummaryProps) => {
  return (
    <div className="bg-muted p-4 rounded-md space-y-2">
      <div className="flex justify-between text-sm">
        <span>Sub Total (Product Cost):</span>
        <span>Br {totalItemAmount.toFixed(2)}</span>
      </div>
      <div className="flex justify-between text-sm">
        <span>Additional Costs ({totalQuantity.toFixed(2)} kg @ Br {totalUnitCost.toFixed(2)}/kg):</span>
        <span>Br {totalAdditionalCosts.toFixed(2)}</span>
      </div>
      <div className="flex justify-between font-medium border-t pt-2">
        <span>Total Amount ({totalQuantity.toFixed(2)} kg):</span>
        <span>Br {grandTotal.toFixed(2)}</span>
      </div>
      {vatApplicable && (
        <div className="text-xs text-muted-foreground">VAT applicable</div>
      )}
      {itemsCount === 0 && (
        <div className="text-xs text-muted-foreground italic mt-2">
          Add products above to see cost calculations
        </div>
      )}
    </div>
  );
};
